module.exports = __webpack_public_path__ + "img/vector.84c404e9.svg";